module.exports = __webpack_public_path__ + "img/lista_precios.1d03c443.jpg";